import { useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import { useEffect, useState, useContext } from "react";
import moment from "moment";
import Select from "react-select";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Schedule.css";
import menuLookup from "../../assets/images/menuLookup.svg";

function Schedule(props) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const accountOptions = [];
  const [accountSummary, setAccountSummary] = useState([]);
  const [accountId, setAccountId] = useState(0);
  const [accountLocationNumber, setAccountLocationNumber] = useState(0);
  const [accountLocation, setAccountLocation] = useState("");

  useEffect(() => {
    props.setTab("schedule");
    setAccountSummary(props.accountSummary);
  }, [props]);

  useEffect(() => {
    accountSummary.forEach((account) => {
      account.locations.forEach((location) => {
        let option = {
          value:
            account.accountId +
            "#~#" +
            account.name +
            "#~#" +
            location.locationNumber,
          label:
            account.name +
            (account.locations.length > 1 ? " - " + location.name : ""),
          washtypeIds: location.washTypeIds,
        };
        accountOptions.push(option);
      });
    });
  });

  useEffect(() => {
    const account = accountSummary.find((item) => item.accountId == accountId);

    const location = account?.locations.find(
      (item) => item.locationNumber == accountLocationNumber,
    );

    setAccountLocation(location);

    console.log("first location is", location);
  }, [accountId, accountLocationNumber]);

  return (
    <Col className="form-container">
      <Row className="head-label">
        <Col xs={8} style={{ padding: "unset" }}>
          {t("schedule.label")}
        </Col>
      </Row>

      <Row className="form-align-center" style={{ marginTop: "10px" }}>
        <Form.Group as={Col} className="mb-3" controlId="formPlaintextAccount">
          <Row>
            <Form.Label column sm="6">
              {t("account.label")}
            </Form.Label>
          </Row>
          <Row>
            <Col sm="12">
              <Select
                options={accountOptions}
                onChange={(e) => {
                  let data = e.value.split("#~#");
                  setAccountId(data[0]);
                  setAccountLocationNumber(data[2]);
                }}
              />
            </Col>
          </Row>

          {accountLocation && (
            <Row style={{ marginTop: "20px" }}>
              <Col className="form-align-center address-section">
                <b className="address-label">{t("address.label")}</b>
                <div className="address-block">
                  <div className="address-name">{accountLocation.name}</div>
                  <div className="address-line">
                    {accountLocation.addressLine1}
                  </div>
                  {accountLocation.addressLine2 && (
                    <div className="address-line">
                      {accountLocation.addressLine2}
                    </div>
                  )}
                  <div className="address-city">
                    {accountLocation.city}, {accountLocation.state}{" "}
                    {accountLocation.zip}
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Form.Group>
      </Row>
    </Col>
  );
}

export default Schedule;
